import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-image-handler',
	templateUrl: './image-handler.component.html',
	styleUrls: ['./image-handler.component.scss'],
	standalone: false,
})
export class ImageHandlerComponent {
	private _product: any;
	// @Input() product: any;

	@Input()
	set product(value: any) {
		this._product = value;
		this.hasThumbnailError = false;
	}

	get product(): any {
		return this._product;
	}
	hasThumbnailError: boolean = false;
}
